var _style, _path, _line, _line2, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _line3, _defs, _defs2, _g24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeiCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113 111.8",
    style: {
      enableBackground: "new 0 0 113 111.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:none;}\n\t.st2{fill:#4CB748;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#58595C;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st7{clip-path:url(#SVGID_00000147914021774286956800000005767819258887464606_);}\n\t.st8{fill:url(#SVGID_00000086689958315170627970000004742751654055228556_);}\n\t.st9{clip-path:url(#SVGID_00000107580402976259395320000013042933446416998056_);}\n\t.st10{fill:url(#SVGID_00000116944979290233327060000009516473339005965975_);}\n\t.st11{fill:#58595B;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.9639,
    y1: 84.2056,
    x2: -0.00002260184,
    y2: 84.2056,
    gradientTransform: "matrix(1 0 0 -1 0 113.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B17C30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03515,
    style: {
      stopColor: "#BB9040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1144,
    style: {
      stopColor: "#D1B961"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1768,
    style: {
      stopColor: "#DFD376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    style: {
      stopColor: "#E4DD7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3823,
    style: {
      stopColor: "#E3D37B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4987,
    style: {
      stopColor: "#E2CA78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    style: {
      stopColor: "#C89D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8233,
    style: {
      stopColor: "#BE8C39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8475,
    style: {
      stopColor: "#C1913F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#C9A052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    style: {
      stopColor: "#D7B971"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    style: {
      stopColor: "#EADB9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F6BE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91,14c-0.4-0.3-0.8-0.7-0.9-1.3l-0.8-3c-0.3-1.1-1.4-1.8-2.6-1.6l-3.1,0.6c-1,0.2-2-0.3-2.4-1.2l-0.9-1.8 l-0.5-1c-0.5-1-1.7-1.5-2.8-1.1L74.1,5c-0.9,0.4-2,0.1-2.6-0.7l-1.9-2.5c-0.7-0.9-2-1.2-3-0.5L64,2.9c-0.8,0.5-1.9,0.4-2.7-0.2 l-2.3-2.1c-0.8-0.8-2.2-0.8-3,0l-2.3,2.1C53.1,3.4,52,3.5,51.1,3l-2.7-1.6c-1-0.6-2.3-0.4-2.9,0.6l-1.8,2.5 c-0.6,0.8-1.6,1.1-2.6,0.8L38.2,4c-1.1-0.4-2.3,0.1-2.8,1.1L34.1,8c-0.4,0.9-1.4,1.4-2.4,1.2l-3.1-0.6c-1.1-0.2-2.2,0.5-2.5,1.6 l-0.8,3c-0.3,1-1.1,1.6-2.1,1.6l-3.1,0c-1.2,0-2.1,0.9-2.2,2L17.5,20c-0.1,1-0.8,1.8-1.8,2l-3.1,0.6c-1.1,0.2-1.9,1.3-1.8,2.4 l0.3,3.1c0.1,1-0.5,1.9-1.4,2.3l-2.9,1.1c-1.1,0.4-1.6,1.6-1.3,2.7l0.9,3c0.3,1-0.1,2-1,2.5l-2.6,1.6c-1,0.6-1.3,1.9-0.8,2.9L3.5,47 c0.5,0.9,0.3,2-0.5,2.6l-2.3,2.1c-0.9,0.8-1,2.1-0.3,3l1.9,2.5c0.2,0.3,0.4,0.6,0.4,1h14.4c1.6,0,2.9-1.2,3-2.8 c1.4-19.6,17.8-35,37.8-35c8.5,0,16.3,2.8,22.7,7.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 83.8,
    y1: 106.7,
    x2: 57.9,
    y2: 58.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 57.9,
    y1: 58.1,
    x2: 91,
    y2: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.9,14L80.6,27.8c9.2,6.9,15.2,17.9,15.2,30.3c0,6.6-1.7,12.8-4.7,18.2c-0.8,1.4-0.4,3.1,1,4l9.4,6.1 c1.4,0.9,3.4,0.5,4.2-1c4.8-8.3,7.3-17.7,7.3-27.4C113,40.8,104.8,24.4,90.9,14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.4,50.7c-0.2,0.1-0.4,0.2-0.7,0.1l-6.5-1.6c-0.3-0.1-0.5-0.2-0.6-0.4c-0.1-0.2-0.1-0.5-0.1-0.8 c0.1-0.3,0.2-0.5,0.4-0.7c0.2-0.1,0.4-0.2,0.7-0.1l5.9,1.4l0.8-3.2c0.1-0.6,0.5-0.9,1-0.7c0.5,0.1,0.7,0.5,0.5,1.1l-1,4.3 C16.7,50.3,16.6,50.6,16.4,50.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.1,44.2c-0.2,0.1-0.4,0.1-0.7,0l-6.2-2.6c-0.3-0.1-0.4-0.3-0.5-0.5c-0.1-0.2-0.1-0.5,0.1-0.7l1.8-4.3 c0.3-0.6,0.6-0.8,1-0.6c0.4,0.2,0.5,0.6,0.3,1.2L12.5,40l1.8,0.8l1.3-3.1c0.3-0.6,0.6-0.8,1.1-0.6c0.4,0.2,0.5,0.6,0.3,1.2 l-1.3,3.1l2,0.8l1.4-3.3c0.3-0.6,0.6-0.8,1.1-0.6c0.4,0.2,0.5,0.6,0.3,1.2l-1.8,4.3C18.5,43.9,18.3,44.1,18.1,44.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.2,37.7c-0.2,0.1-0.5,0-0.7-0.1l-5.8-3.4c-0.2-0.1-0.4-0.3-0.4-0.6c-0.1-0.2,0-0.5,0.2-0.8 c0.2-0.3,0.4-0.4,0.6-0.5c0.2-0.1,0.5,0,0.7,0.1l5.8,3.4c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.2,0,0.5-0.2,0.8 C21.6,37.4,21.4,37.6,21.2,37.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.7,30.8c-0.7,0.3-1.4,0.3-2.2,0.1c-0.7-0.2-1.4-0.6-2.1-1.2c-0.6-0.6-1.1-1.2-1.3-2c-0.2-0.7-0.2-1.4,0-2.2 c0.2-0.7,0.6-1.4,1.2-2.1c0.8-0.8,1.6-1.4,2.6-1.6c0.2,0,0.3,0,0.4,0s0.2,0.1,0.3,0.2c0.2,0.1,0.2,0.3,0.3,0.5c0,0.2,0,0.4-0.1,0.5 c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.7,0.3-1,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.6,0.6-0.8,1.2-0.8,1.9 c0.1,0.6,0.4,1.3,1.1,1.9c1.4,1.3,2.7,1.3,3.8,0.1c0.2-0.2,0.4-0.5,0.5-0.8c0.1-0.3,0.2-0.6,0.3-1c0-0.1,0.1-0.3,0.1-0.3 c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.4 c-0.1,1-0.6,1.9-1.4,2.8C27.1,30,26.4,30.5,25.7,30.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.4,26.2c-0.2,0-0.4-0.1-0.6-0.4l-4.1-5.3c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.2,0.2-0.4,0.4-0.6l3.7-2.8 c0.5-0.4,0.9-0.4,1.2,0c0.3,0.4,0.2,0.8-0.3,1.2l-2.9,2.2l1.2,1.6l2.6-2c0.5-0.4,0.9-0.4,1.2,0c0.3,0.4,0.2,0.8-0.3,1.2l-2.6,2 l1.3,1.7l2.9-2.2c0.5-0.4,0.9-0.4,1.2,0c0.3,0.4,0.2,0.8-0.3,1.2L31.1,26C30.8,26.2,30.6,26.2,30.4,26.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.5,18.3c0.1,0.2,0.1,0.4,0,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1 l-2.6-1.3c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0-0.6,0.2l-0.9,0.5l1.1,2.2c0.1,0.3,0.2,0.5,0.1,0.7c-0.1,0.2-0.3,0.4-0.5,0.5 c-0.3,0.1-0.5,0.2-0.8,0.1c-0.2-0.1-0.4-0.2-0.6-0.5l-3-6c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.2,0.3-0.4,0.5-0.5l2.9-1.5 c1-0.5,1.8-0.7,2.5-0.5c0.7,0.1,1.2,0.6,1.6,1.3c0.3,0.6,0.4,1.2,0.2,1.7s-0.5,1.1-1.1,1.5c0.3-0.1,0.5-0.1,0.8-0.1 c0.2,0,0.5,0.1,0.8,0.3l1.5,0.8C42.3,18,42.4,18.1,42.5,18.3z M38.3,15.6c0.1-0.3,0.1-0.6,0-1C38,14.3,37.8,14,37.5,14 s-0.7,0.1-1.3,0.3l-1.7,0.9l1,2.1l1.7-0.9C37.8,16.1,38.1,15.9,38.3,15.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.7,17.9c-0.2-0.1-0.4-0.3-0.5-0.6l-1.7-5.8l-2,0.6c-0.6,0.2-1,0-1.1-0.5c-0.1-0.5,0.1-0.8,0.7-1l6-1.7 c0.6-0.2,1,0,1.1,0.5c0.1,0.5-0.1,0.8-0.7,1l-2,0.6l1.7,5.8c0.1,0.3,0.1,0.5-0.1,0.7c-0.1,0.2-0.3,0.4-0.6,0.4 C46.1,18,45.9,18,45.7,17.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51,16.7c-0.2-0.1-0.3-0.4-0.4-0.6l-1-6.7c0-0.3,0-0.5,0.2-0.7c0.2-0.2,0.4-0.3,0.7-0.4c0.3,0,0.6,0,0.8,0.1 c0.2,0.1,0.3,0.3,0.4,0.6l1,6.7c0,0.3,0,0.5-0.2,0.7c-0.2,0.2-0.4,0.3-0.7,0.4C51.4,16.9,51.2,16.8,51,16.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.3,16.2C54.1,16,54,15.8,54,15.5l-0.2-6.7c0-0.3,0.1-0.5,0.2-0.7c0.2-0.2,0.4-0.2,0.7-0.2l4.5-0.1 c0.3,0,0.6,0,0.7,0.2c0.2,0.1,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6s-0.4,0.2-0.7,0.2l-3.4,0.1l0,1.9l3.2-0.1c0.3,0,0.6,0,0.7,0.2 c0.2,0.1,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.1-0.4,0.2-0.7,0.2L56,12.8l0.1,2.7c0,0.3-0.1,0.5-0.3,0.7 c-0.2,0.2-0.4,0.3-0.7,0.3C54.8,16.4,54.5,16.3,54.3,16.2z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.3,16.2c-0.2-0.2-0.2-0.4-0.2-0.7l0.6-6.7c0-0.3,0.1-0.5,0.3-0.6C62.3,8,62.5,8,62.8,8 c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.2,0.4,0.2,0.7l-0.6,6.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.1-0.5,0.2-0.8,0.2 C61.7,16.5,61.4,16.4,61.3,16.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.6,16.5c-0.1-0.2-0.2-0.4-0.1-0.7L66,9.3C66,9,66.2,8.8,66.4,8.7c0.2-0.1,0.4-0.1,0.7-0.1l4.5,1 c0.6,0.1,0.9,0.4,0.8,0.9c-0.1,0.5-0.5,0.6-1.1,0.5l-3.5-0.8l-0.4,1.9l3.2,0.7c0.6,0.1,0.9,0.5,0.8,0.9c-0.1,0.5-0.5,0.6-1.1,0.5 L67,13.6l-0.5,2.1l3.5,0.8c0.6,0.1,0.9,0.5,0.8,0.9c-0.1,0.5-0.5,0.6-1.1,0.5l-4.5-1C64.9,16.8,64.7,16.7,64.6,16.5z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.4,18.1c-0.1-0.2-0.1-0.4,0-0.7l2.7-6.1c0.1-0.3,0.3-0.4,0.5-0.5c0.2-0.1,0.5,0,0.7,0.1l2.4,1.1 c0.9,0.4,1.6,0.9,2.2,1.5c0.5,0.6,0.8,1.3,0.9,2c0.1,0.7,0,1.5-0.4,2.3c-0.4,0.8-0.8,1.4-1.4,1.9s-1.3,0.7-2.1,0.7 c-0.8,0-1.7-0.2-2.6-0.6l-2.4-1.1C71.7,18.5,71.5,18.3,71.4,18.1z M78.6,16.9c0.7-1.7,0.2-2.9-1.6-3.7l-1.3-0.6l-2.2,5l1.3,0.6 C76.6,19,77.9,18.5,78.6,16.9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.7,31.6c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0-0.2,0-0.4l0.4-1 L90,27.4l-1.1,0.3c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.3-0.2-0.5s0-0.3,0.2-0.4c0.1-0.1,0.1-0.1,0.3-0.1 l5.3-1.3c0.1,0,0.3,0,0.4,0c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.3,0,0.4l-1.9,5.1 C92.8,31.4,92.7,31.5,92.7,31.6z M91.1,27.1l1.4,1.6l0.9-2.3L91.1,27.1z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.4,33.2c-0.1-0.5,0-1,0.3-1.5c0.2-0.5,0.6-0.9,1.1-1.2s1-0.5,1.6-0.6c0.5,0,1,0.1,1.5,0.3 c0.5,0.3,0.9,0.7,1.2,1.2c0.4,0.7,0.7,1.4,0.6,2.1c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.2-0.1-0.3-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.3-0.5-0.7-0.8-1.2-0.8c-0.4-0.1-0.9,0.1-1.5,0.5c-1.1,0.7-1.4,1.6-0.7,2.6c0.1,0.2,0.3,0.4,0.4,0.5c0.2,0.1,0.4,0.3,0.7,0.4 c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.2,0.1s-0.2,0-0.3,0 c-0.7-0.3-1.2-0.7-1.7-1.4C93.7,34.3,93.5,33.7,93.4,33.2z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.5,38.7c0-0.2,0.2-0.3,0.3-0.4l3.9-1.9l-0.7-1.3c-0.2-0.4-0.1-0.7,0.2-0.9c0.3-0.2,0.6,0,0.8,0.4l2,4 c0.2,0.4,0.1,0.7-0.2,0.9c-0.3,0.2-0.6,0-0.8-0.4l-0.7-1.3l-3.9,1.9c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.4-0.4 C96.5,39,96.5,38.8,96.5,38.7z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.1,42.3c0.1-0.2,0.2-0.3,0.4-0.4l4.5-1.7c0.2-0.1,0.4-0.1,0.5,0c0.2,0.1,0.3,0.2,0.4,0.4s0.1,0.4,0,0.6 c-0.1,0.2-0.2,0.3-0.4,0.4L99,43.3c-0.2,0.1-0.4,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.4-0.4C98.1,42.6,98.1,42.5,98.1,42.3z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.9,47.7c0.1,0.1,0.1,0.2,0.2,0.3c0,0.2,0,0.4,0,0.5c-0.1,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2,0-0.3,0l-5.3-1.2 c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2,0-0.3,0-0.5c0-0.1,0.1-0.3,0.2-0.4l4-3.7c0.1-0.1,0.1-0.1,0.2-0.1 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.3,0.3,0.5c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.2-0.2,0.3l-3.3,2.9l4.4,0.9 C105.7,47.5,105.8,47.6,105.9,47.7z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.6,50.7c0.1-0.1,0.2-0.2,0.4-0.2l4.7-0.6c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.2,0.3,0.2,0.5l0.4,3.2 c0.1,0.5-0.1,0.7-0.4,0.7c-0.3,0-0.5-0.2-0.6-0.6l-0.3-2.5l-1.4,0.2l0.3,2.3c0.1,0.5-0.1,0.7-0.4,0.7c-0.3,0-0.5-0.2-0.6-0.6 l-0.3-2.3l-1.5,0.2l0.3,2.5c0.1,0.5-0.1,0.7-0.4,0.7c-0.3,0-0.5-0.2-0.6-0.6l-0.4-3.2C100.4,51,100.5,50.8,100.6,50.7z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.4,62.7c-0.4,0-0.5-0.3-0.5-0.7l0.2-3.4c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.2 c0.2,0,0.4,0.1,0.5,0.3l1.9,2.1c0.4,0.5,0.8,0.7,1.2,0.7c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.6c0-0.2,0-0.5-0.1-0.7 c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.1-0.1-0.2-0.1-0.2s0-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0.2,0.3,0.3,0.6,0.4,1c0.1,0.4,0.1,0.7,0.1,1.1c0,0.4-0.1,0.8-0.3,1.1 s-0.4,0.6-0.6,0.7s-0.6,0.2-0.9,0.2c-0.3,0-0.7-0.1-0.9-0.3c-0.3-0.2-0.6-0.4-0.9-0.8l-1.3-1.5l-0.1,2.1 C101.9,62.5,101.7,62.7,101.4,62.7z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.4,63.7c0.6-0.3,1.4-0.4,2.4-0.2c1,0.2,1.7,0.5,2.1,1c0.5,0.5,0.6,1.1,0.5,1.9s-0.5,1.3-1.1,1.7 s-1.4,0.4-2.3,0.2c-1-0.2-1.7-0.5-2.2-1c-0.5-0.5-0.6-1.1-0.5-1.9C100.5,64.5,100.8,64,101.4,63.7z M101.7,66.3 c0.3,0.2,0.8,0.4,1.5,0.5c0.7,0.1,1.2,0.1,1.6,0c0.3-0.1,0.5-0.3,0.6-0.7c0.1-0.4-0.1-0.6-0.4-0.9c-0.3-0.2-0.8-0.4-1.5-0.5 c-0.7-0.1-1.2-0.1-1.6,0c-0.4,0.1-0.6,0.3-0.6,0.7C101.3,65.8,101.4,66.1,101.7,66.3z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.1,72.9c-0.3-0.1-0.4-0.4-0.3-0.8l1-3.3c0.1-0.2,0.1-0.3,0.3-0.4c0.1-0.1,0.3-0.1,0.4-0.1 c0.2,0.1,0.3,0.2,0.5,0.4l1.3,2.5c0.3,0.6,0.6,0.9,1,1c0.2,0.1,0.4,0,0.6-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7 c0-0.2-0.1-0.5-0.1-0.7c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.4,0c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.3,0.2,0.7,0.2,1c0,0.4,0,0.7-0.1,1.1c-0.1,0.4-0.3,0.8-0.5,1c-0.2,0.3-0.5,0.5-0.8,0.6 c-0.3,0.1-0.6,0.1-0.9,0c-0.3-0.1-0.6-0.3-0.9-0.5s-0.5-0.6-0.7-1l-0.9-1.8l-0.6,2.1C99.6,72.8,99.4,73,99.1,72.9z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97,77.7c-0.3-0.1-0.4-0.4-0.2-0.8l1.4-3.2c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.1,0.4,0 c0.2,0.1,0.3,0.2,0.4,0.5l1,2.7c0.2,0.6,0.5,1,0.9,1.1c0.2,0.1,0.4,0.1,0.6,0c0.2-0.1,0.3-0.2,0.4-0.5c0.1-0.2,0.1-0.4,0.2-0.6 c0-0.2,0-0.5,0-0.8c0-0.1,0-0.2,0-0.3s0-0.1,0-0.2c0.1-0.1,0.1-0.2,0.3-0.2s0.3,0,0.4,0c0.1,0,0.2,0.1,0.2,0.2 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.1,0.7,0,1.1c0,0.4-0.1,0.7-0.3,1.1c-0.2,0.4-0.4,0.7-0.6,1s-0.5,0.4-0.8,0.5 c-0.3,0.1-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.3-0.4-0.6-0.6-1.1l-0.7-1.9l-0.9,2C97.6,77.7,97.3,77.8,97,77.7z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9,69.4c0.1-0.2,0.3-0.4,0.6-0.4l6.5-1.6c0.3-0.1,0.5,0,0.7,0.1c0.2,0.1,0.3,0.4,0.4,0.7 c0.1,0.3,0.1,0.6-0.1,0.8c-0.1,0.2-0.3,0.4-0.6,0.4L10.1,71c-0.3,0.1-0.5,0-0.7-0.1c-0.2-0.1-0.3-0.4-0.4-0.7 C8.8,69.9,8.9,69.6,9,69.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10.4,74.8c-0.1-0.6-0.1-1.1,0.1-1.6c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.4-0.1,0.6,0 c0.2,0.1,0.3,0.2,0.4,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.4c-0.1,0.4-0.1,0.8,0,1.2c0,0.4,0.2,0.8,0.3,1.2 c0.2,0.5,0.5,0.9,0.7,1.1s0.6,0.3,0.9,0.1c0.2-0.1,0.4-0.3,0.4-0.6c0-0.3,0-0.8-0.2-1.6c-0.2-0.8-0.2-1.5-0.2-2s0.1-1,0.4-1.3 c0.2-0.3,0.5-0.6,1-0.7c0.5-0.2,0.9-0.2,1.4-0.1c0.5,0.1,0.9,0.4,1.4,0.9c0.4,0.4,0.8,1,1,1.6c0.5,1.1,0.6,2.2,0.3,3.2 c0,0.2-0.1,0.3-0.2,0.4s-0.2,0.2-0.3,0.2c-0.2,0.1-0.4,0.1-0.6,0c-0.2-0.1-0.3-0.2-0.4-0.3c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0-0.4c0.1-0.4,0.1-0.8,0.1-1.1c0-0.3-0.1-0.7-0.3-1.1c-0.2-0.5-0.4-0.8-0.7-1.1c-0.3-0.2-0.6-0.3-0.9-0.1 c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.3,0.1,0.7,0.1,1.2c0.2,1.2,0.2,2.1,0.1,2.7c-0.2,0.6-0.5,1-1.2,1.3 c-0.5,0.2-1,0.2-1.4,0.1c-0.5-0.1-0.9-0.4-1.3-0.9s-0.7-1-1-1.7C10.7,76,10.5,75.4,10.4,74.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.8,83.5c-0.1-0.8,0.1-1.5,0.4-2.1s0.9-1.2,1.6-1.7c0.7-0.5,1.5-0.7,2.2-0.8s1.5,0.1,2.1,0.5 c0.7,0.4,1.2,0.9,1.7,1.7c0.5,0.8,0.8,1.5,0.9,2.3c0.1,0.8-0.1,1.5-0.4,2.1s-0.9,1.2-1.6,1.7s-1.5,0.7-2.2,0.8s-1.5-0.1-2.1-0.5 c-0.7-0.4-1.3-0.9-1.8-1.7C15.2,85,14.9,84.3,14.8,83.5z M18.5,86.1c0.7,0.1,1.4-0.1,2.2-0.6c0.8-0.5,1.3-1.1,1.4-1.7 c0.2-0.6,0-1.3-0.4-1.9s-1-1-1.6-1.1c-0.6-0.1-1.4,0.1-2.1,0.6c-0.8,0.5-1.3,1.1-1.4,1.7c-0.2,0.6-0.1,1.3,0.4,1.9 C17.3,85.6,17.8,86,18.5,86.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28,97.9c-0.3,0.4-0.7,0.4-1.2-0.1l-3.4-2.9c-0.5-0.4-0.6-0.8-0.2-1.2c0.3-0.4,0.7-0.3,1.2,0.1l0.9,0.8 l3.2-3.7l-1.3-0.3c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.1-0.2-0.3-0.3-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.3,0.7-0.2l2.3,0.5 c0.3,0.1,0.6,0.2,0.9,0.4c0.2,0.2,0.3,0.4,0.4,0.6s0,0.5-0.2,0.7l-4,4.6l0.9,0.8C28.3,97.2,28.4,97.6,28,97.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.8,95.8c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.3,0.4-0.5,0.5l-6.9,3.5c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.2,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.1-0.5,0.1-0.7c0.1-0.1,0.2-0.3,0.4-0.3l6-3l-3.1-1.9 c-0.5-0.3-0.7-0.7-0.4-1.1c0.3-0.4,0.7-0.5,1.2-0.1l4.4,2.7C38.6,95.5,38.7,95.6,38.8,95.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.7,104.3c-0.2,0.4-0.6,0.6-1.2,0.3l-0.4-0.2l-0.3,0.6c-0.1,0.3-0.3,0.5-0.5,0.5c-0.2,0.1-0.5,0.1-0.8,0 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.1-0.5,0-0.7l0.3-0.6l-2.9-1.2c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4,0-0.6s0.2-0.4,0.5-0.5 l5.5-3.3c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.4,0.3,0.6,0.5c0.1,0.2,0.1,0.5,0,0.7l-1.7,4.3l0.4,0.2 C43.7,103.5,43.9,103.8,43.7,104.3z M39,101.6l1.9,0.7l1-2.5L39,101.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.7,106c-0.1,0.5-0.5,0.6-1.1,0.5l-0.5-0.1l-0.1,0.7c-0.1,0.3-0.2,0.5-0.4,0.6c-0.2,0.1-0.5,0.1-0.8,0.1 c-0.3-0.1-0.5-0.2-0.7-0.4c-0.1-0.2-0.2-0.4-0.1-0.7l0.1-0.7l-3.1-0.7c-0.3-0.1-0.5-0.2-0.6-0.3c-0.1-0.2-0.2-0.4-0.1-0.6 c0-0.2,0.2-0.4,0.4-0.6l4.9-4.2c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0c0.3,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.2,0.4,0.2,0.7 l-1,4.5l0.5,0.1C51.5,105.3,51.8,105.5,51.7,106z M46.5,104.2l2,0.4L49,102L46.5,104.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59.5,107.9c0,0.5-0.3,0.7-1,0.7l-4.8-0.2c-0.3,0-0.5-0.1-0.6-0.2c-0.2-0.2-0.2-0.3-0.2-0.6 c0-0.3,0.1-0.5,0.4-0.8l3-2.7c0.7-0.6,1-1.2,1-1.7c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.3,0-0.6,0-0.9,0.1 c-0.3,0.1-0.6,0.2-1,0.4c-0.2,0.1-0.3,0.1-0.3,0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.5-0.3c-0.1-0.2-0.2-0.3-0.2-0.6 c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.2,0.9-0.4,1.4-0.6c0.5-0.1,1-0.2,1.5-0.2c0.6,0,1.2,0.1,1.6,0.3 c0.5,0.2,0.8,0.5,1,0.9c0.2,0.4,0.3,0.8,0.3,1.2c0,0.5-0.1,0.9-0.4,1.3c-0.2,0.4-0.6,0.9-1.2,1.3l-2.1,1.9l3,0.1 C59.2,107.1,59.5,107.4,59.5,107.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61,104.2c-0.2-0.2-0.3-0.4-0.4-0.7c0-0.3,0.1-0.5,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.4c0.3,0,0.6,0,0.8,0.2 c0.2,0.2,0.3,0.4,0.4,0.7c0,0.3-0.1,0.5-0.3,0.8c-0.2,0.2-0.4,0.3-0.8,0.4C61.5,104.4,61.2,104.4,61,104.2z M61.3,108.2 c-0.2-0.2-0.3-0.4-0.4-0.7c0-0.3,0.1-0.5,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.4c0.3,0,0.6,0,0.8,0.2c0.2,0.2,0.3,0.4,0.4,0.7 c0,0.3-0.1,0.5-0.3,0.8c-0.2,0.2-0.4,0.3-0.8,0.4C61.8,108.4,61.5,108.4,61.3,108.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.4,106c0.1,0.5-0.2,0.8-0.8,0.9l-4.8,1c-0.3,0.1-0.5,0-0.7-0.1s-0.3-0.3-0.3-0.5c-0.1-0.3,0-0.6,0.2-0.9 l2.2-3.3c0.5-0.7,0.7-1.4,0.6-1.9c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.1-0.5-0.2-0.9-0.1c-0.3,0.1-0.6,0.2-0.9,0.3 c-0.3,0.2-0.5,0.4-0.9,0.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.3,0-0.5-0.1c-0.2-0.1-0.3-0.3-0.3-0.5 c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.2-0.3c0.3-0.3,0.7-0.6,1.2-0.9c0.5-0.3,1-0.4,1.5-0.5c0.6-0.1,1.2-0.1,1.6,0 c0.5,0.1,0.9,0.3,1.2,0.6c0.3,0.3,0.5,0.7,0.6,1.1c0.1,0.5,0.1,0.9-0.1,1.4c-0.1,0.5-0.4,1-0.8,1.6l-1.6,2.4l3-0.6 C70.9,105.4,71.3,105.5,71.4,106z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.6,105c-0.8-0.5-1.5-1.4-2-2.7c-0.5-1.3-0.6-2.4-0.4-3.3c0.3-0.9,0.9-1.6,2-2s2-0.4,2.8,0.1 c0.8,0.5,1.5,1.4,2,2.7c0.5,1.3,0.6,2.4,0.4,3.3c-0.3,0.9-0.9,1.6-2,2C75.4,105.5,74.5,105.5,73.6,105z M76.7,102.7 c0-0.5-0.1-1.2-0.5-2.2c-0.4-1-0.8-1.6-1.1-1.9c-0.4-0.3-0.8-0.4-1.3-0.2c-0.5,0.2-0.7,0.5-0.8,1c0,0.5,0.1,1.2,0.5,2.2 c0.4,0.9,0.8,1.6,1.1,1.9c0.4,0.3,0.8,0.4,1.3,0.2C76.4,103.6,76.6,103.3,76.7,102.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.8,98.7c0.3,0.4,0.1,0.8-0.4,1.1l-3.8,2.3c-0.5,0.3-1,0.3-1.2-0.1c-0.3-0.4-0.1-0.8,0.4-1.1l1-0.6L80.2,96 l-0.7,1.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.5,0-0.8l1.2-2 c0.2-0.3,0.4-0.5,0.6-0.7c0.2-0.1,0.5-0.2,0.7-0.2c0.2,0,0.4,0.2,0.6,0.4l3.2,5.2l1-0.6C86.1,98.2,86.5,98.3,86.8,98.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.9,89c1,0.1,1.9,0.7,2.8,1.7c0.6,0.7,1,1.4,1.2,2.1c0.2,0.7,0.2,1.4,0,2c-0.2,0.6-0.6,1.2-1.1,1.7 c-0.4,0.3-0.8,0.6-1.3,0.8c-0.5,0.2-0.9,0.3-1.4,0.4c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2-0.2-0.3-0.2-0.5 c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.7-0.2,1-0.3c0.3-0.1,0.5-0.2,0.7-0.4 c0.4-0.4,0.6-0.8,0.5-1.4s-0.3-1.2-0.8-1.8c0,0.4,0,0.7-0.2,1.1c-0.2,0.4-0.4,0.7-0.7,1c-0.4,0.4-0.8,0.6-1.3,0.7 s-0.9,0.1-1.4-0.1s-0.9-0.4-1.2-0.8c-0.4-0.4-0.6-0.9-0.7-1.4c-0.1-0.5,0-1,0.2-1.5c0.2-0.5,0.5-0.9,1-1.3 C86,89.2,86.9,88.8,87.9,89z M88.4,92.1c0-0.4-0.1-0.7-0.4-1s-0.6-0.5-0.9-0.5c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.5,0.6-0.5,0.9 c0,0.3,0.1,0.7,0.4,1c0.3,0.3,0.6,0.5,0.9,0.5c0.3,0,0.7-0.1,1-0.4C88.2,92.7,88.3,92.4,88.4,92.1z"
  })))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 80.1,
    y1: 28.4,
    x2: 92.1,
    y2: 12.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067929310851562454580000011231250328041996678_",
    d: "M57.5,28.9c-2.4,0-4.1,0.4-5.4,0.7l-0.5,0.1L50.7,30 c-6.7,2-13.1,6.3-16.6,11.4c0.1-0.2,0.2-0.3,0.3-0.5c0.9-1.2,1.9-2.3,2.9-3.4c0.7-0.7,1.5-1.4,2.3-2.1c5.5-4.4,11-5.5,12.8-5.9 c1.3-0.2,3-0.5,5.5-0.6C57.9,28.9,57.7,28.9,57.5,28.9 M56.7,29c0.5-0.1,1-0.1,1.4-0.1c-1,0-2.4,0.1-4.8,0.8l-0.1,0 c-1.4,0.5-2.3,1-3.1,1.4c-0.8,0.4-20,11.1-21.3,26.2c0,0.3,0,0.6,0,0.8c0,1.6,0.1,3.2,0.4,4.7c0.1,0.6,0.2,1.1,0.3,1.7 c-3.3-15.4,19.6-31.8,20.6-32.5l0.6-0.4l0.3-0.2C52.6,30.4,54.5,29.3,56.7,29 M57.8,30.3c0.1-0.7,0.1-1.2,0.2-1.4 c-0.5,0.1-1.8,1.8-3.7,5c-6.2,9.6-15.6,16.9-20,27.8c-2.7,6.7-2.1,11.4,2.1,16.2c0.3,0.3,0.6,0.6,0.9,1c1.1,1.1,2.2,2,3.4,2.9 c0.4,0.3,0.7,0.5,1.1,0.7c-7.2-4.8-7.2-10.6-6-14.5c4-12.8,15.4-20.9,20.7-32.9l0.2-0.6l0.1-0.3C57.4,32.7,57.7,32,57.8,30.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129197382955918526460000005514556722242964888_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067929310851562454580000011231250328041996678_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129197382955918526460000005514556722242964888_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039128816051962114090000008890752411389262778_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.7359,
    y1: 25.8893,
    x2: 49.7359,
    y2: 84.368,
    gradientTransform: "matrix(1 0 0 -1 0 113.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1767,
    style: {
      stopColor: "#B17C30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2168,
    style: {
      stopColor: "#C39B53",
      stopOpacity: 0.9492
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#E1CC8C",
      stopOpacity: 0.8684
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3458,
    style: {
      stopColor: "#F3EAAF",
      stopOpacity: 0.8185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3799,
    style: {
      stopColor: "#FAF6BC",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3841,
    style: {
      stopColor: "#F5EDAE",
      stopOpacity: 0.6443
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    style: {
      stopColor: "#F0E5A1",
      stopOpacity: 0.4936
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    style: {
      stopColor: "#ECDD96",
      stopOpacity: 0.3596
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4002,
    style: {
      stopColor: "#E9D78C",
      stopOpacity: 0.247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4068,
    style: {
      stopColor: "#E6D285",
      stopOpacity: 0.1557
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4144,
    style: {
      stopColor: "#E4CE7F",
      stopOpacity: 0.08555
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4237,
    style: {
      stopColor: "#E3CB7B",
      stopOpacity: 0.03636
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    style: {
      stopColor: "#E2CA78",
      stopOpacity: 0.00799
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4668,
    style: {
      stopColor: "#E2CA78",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E1C977",
      stopOpacity: 0.01256
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#DFC573",
      stopOpacity: 0.05488
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5974,
    style: {
      stopColor: "#DCC06D",
      stopOpacity: 0.1274
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    style: {
      stopColor: "#D7B865",
      stopOpacity: 0.2303
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6454,
    style: {
      stopColor: "#D1AD5B",
      stopOpacity: 0.3638
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    style: {
      stopColor: "#CAA14E",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#C1923F",
      stopOpacity: 0.7187
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6928,
    style: {
      stopColor: "#BE8C39",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#BC8A37",
      stopOpacity: 0.9472
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B17C2F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 28.9,
    style: {
      fill: "url(#SVGID_00000039128816051962114090000008890752411389262778_)"
    },
    width: 68.1,
    height: 58.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111170408892668536950000014849749521515188885_",
    d: "M58.5,28.9c-0.1,0-0.3,0-0.5,0c5.9,0,17.5,4.3,23,11.2 l0.6,0.8c0.8,1.1,1.7,2.7,2.4,3.8l0.6,1.3C80.1,36.2,64.2,29.3,58.5,28.9 M57.9,28.9c-0.1,1.1,2.1,2.9,9.2,8.4 C80,47.1,91.8,58,83.3,72.8l0.7-1.3c0.6-1.2,1.3-2.9,1.8-4.2c0.3-1.1,0.7-2.6,1-3.8c1.1-6.2-0.5-11.4-5.1-17.1 C74.7,38.2,58.1,28.9,58,28.9C58,28.9,57.9,28.9,57.9,28.9 M56.9,28.9C50.5,29.5,46,33,60.6,46.8c10.1,9.5,17.9,17.5,17.3,26.3 C77.5,80,69.4,87.4,58,87.4c7.9-0.1,14.9-3.2,19.4-8.6C87.6,65.1,73.2,52.3,62.7,43C52.2,33.6,50.7,28.9,58,28.9 C57.7,28.9,57.2,28.9,56.9,28.9 M57.6,28.9l-0.6,0L56,29c-11.3,0.9-15.8,7.2-15.9,10.9c-0.2,4.5,0.8,9.4,14.7,23.3 c23.4,23.5,4.1,24.2,3.3,24.2c2,0,7.1-0.6,10-5c4.6-8.1-3.2-16.1-10.1-23.2c-9.1-9.3-14.6-15-14.6-21.2c0-4.5,5-9,14.6-9.1 L57.6,28.9 M37.3,37.5c-1.1,1.1-2,2.2-2.9,3.4c-0.1,0.2-0.2,0.3-0.3,0.5C25.5,54.9,37.4,65.7,48.9,76c9,8.1,9.1,11,9.1,11.3 c0.5-0.1,1.4-0.3,1.1-2.3c-0.7-4-5-8.7-9.2-12.8C35.9,58.5,26.2,47,39.7,35.4C38.8,36,38.1,36.7,37.3,37.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040564670511849344500000012583054714270258587_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111170408892668536950000014849749521515188885_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040564670511849344500000012583054714270258587_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039833696332593219770000015119012562424692105_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.9859,
    y1: 25.8893,
    x2: 59.9859,
    y2: 84.368,
    gradientTransform: "matrix(1 0 0 -1 0 113.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B17C30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841,
    style: {
      stopColor: "#C39B53",
      stopOpacity: 0.9492
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    style: {
      stopColor: "#E1CC8C",
      stopOpacity: 0.8684
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2886,
    style: {
      stopColor: "#F3EAAF",
      stopOpacity: 0.8185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3469,
    style: {
      stopColor: "#FAF6BC",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3473,
    style: {
      stopColor: "#F9F5BA",
      stopOpacity: 0.7854
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    style: {
      stopColor: "#F4ECAC",
      stopOpacity: 0.6217
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#F0E4A0",
      stopOpacity: 0.4763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    style: {
      stopColor: "#ECDD95",
      stopOpacity: 0.3465
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#E9D78C",
      stopOpacity: 0.2378
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3808,
    style: {
      stopColor: "#E6D284",
      stopOpacity: 0.1496
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3905,
    style: {
      stopColor: "#E4CE7E",
      stopOpacity: 0.08198
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4024,
    style: {
      stopColor: "#E3CB7A",
      stopOpacity: 0.03466
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4191,
    style: {
      stopColor: "#E2CA78",
      stopOpacity: 0.00749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4656,
    style: {
      stopColor: "#E2CA78",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5345,
    style: {
      stopColor: "#E1C876",
      stopOpacity: 0.01596
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5868,
    style: {
      stopColor: "#DFC472",
      stopOpacity: 0.06664
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6336,
    style: {
      stopColor: "#DBBE6C",
      stopOpacity: 0.1523
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6773,
    style: {
      stopColor: "#D5B462",
      stopOpacity: 0.2732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    style: {
      stopColor: "#CEA856",
      stopOpacity: 0.4293
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7578,
    style: {
      stopColor: "#C69A47",
      stopOpacity: 0.6181
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7891,
    style: {
      stopColor: "#BE8C39",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8165,
    style: {
      stopColor: "#C0913F",
      stopOpacity: 0.8094
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    style: {
      stopColor: "#C89E50",
      stopOpacity: 0.8358
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9024,
    style: {
      stopColor: "#D5B56D",
      stopOpacity: 0.8789
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    style: {
      stopColor: "#E6D595",
      stopOpacity: 0.9385
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F6BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 28.9,
    style: {
      fill: "url(#SVGID_00000039833696332593219770000015119012562424692105_)"
    },
    width: 68.1,
    height: 58.5
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M25.8,62v-8.7h1.7v7.2h4.4V62L25.8,62C25.8,62,25.8,62,25.8,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M39,60.6V62h-6v-8.7h5.9v1.5h-4.2v2.1h3.7v1.4h-3.7v2.3L39,60.6L39,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M40.3,62v-8.7H42V62L40.3,62L40.3,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M43.9,62v-8.7h3.7c0.4,0,0.7,0.1,1,0.2s0.6,0.3,0.8,0.6c0.2,0.2,0.4,0.5,0.5,0.9s0.2,0.6,0.2,1 c0,0.3,0,0.6-0.1,0.9s-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.6,0.6c-0.2,0.1-0.5,0.3-0.7,0.3l2.1,3.3h-1.2l-2-3.1H45V62L43.9,62 L43.9,62L43.9,62z M45,57.9h2.6c0.2,0,0.4,0,0.6-0.1s0.3-0.2,0.4-0.4c0.1-0.1,0.2-0.3,0.3-0.6c0-0.2,0.1-0.4,0.1-0.7 s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.1-0.3-0.3-0.5-0.4s-0.4-0.1-0.6-0.1h-2.6L45,57.9C44.9,57.9,45,57.9,45,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M54.4,62.1c-0.5,0-0.9-0.1-1.3-0.2s-0.7-0.4-1-0.7s-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.8-0.2-1.3s0.1-0.9,0.2-1.3 s0.4-0.7,0.7-1s0.6-0.5,1-0.7c0.4-0.2,0.8-0.2,1.3-0.2s0.9,0.1,1.3,0.2c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.6,1 c0.1,0.4,0.2,0.8,0.2,1.2v0.4h-5.3c0,0.3,0.1,0.6,0.2,0.9c0.1,0.2,0.3,0.5,0.5,0.7s0.4,0.3,0.6,0.4s0.5,0.1,0.8,0.1 c0.2,0,0.4,0,0.6-0.1s0.3-0.1,0.5-0.2c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.3,0.3-0.4l0.9,0.2c-0.1,0.2-0.2,0.4-0.4,0.6 s-0.4,0.3-0.6,0.5s-0.5,0.2-0.8,0.3S54.7,62.1,54.4,62.1z M56.6,58.4c0-0.3-0.1-0.6-0.2-0.8S56,57.1,55.8,57 c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.1-0.8-0.1s-0.5,0-0.8,0.1c-0.2,0.1-0.5,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.4,0.6 s-0.2,0.5-0.2,0.8H56.6L56.6,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M61.3,62.1c-0.4,0-0.8-0.1-1.2-0.2c-0.3-0.2-0.7-0.4-0.9-0.7c-0.2-0.3-0.4-0.6-0.6-1 c-0.1-0.4-0.2-0.8-0.2-1.2s0-0.9,0.2-1.3s0.3-0.7,0.6-1s0.6-0.5,0.9-0.7c0.3-0.2,0.7-0.2,1.2-0.2c0.5,0,1,0.1,1.4,0.4 c0.4,0.2,0.7,0.6,1,1v-1.3h0.9v6.3c0,0.4-0.1,0.8-0.2,1.2S64,63.8,63.7,64c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.8,0.2-1.3,0.2 c-0.7,0-1.3-0.1-1.8-0.4s-0.8-0.6-1.1-1l0.6-0.5c0.2,0.4,0.6,0.6,1,0.8s0.8,0.3,1.3,0.3c0.3,0,0.6,0,0.8-0.1s0.5-0.2,0.7-0.3 c0.2-0.1,0.3-0.3,0.5-0.6c0.1-0.2,0.2-0.5,0.2-0.9v-1.1c-0.1,0.2-0.2,0.4-0.4,0.5c-0.1,0.1-0.3,0.3-0.5,0.4 C62.4,61.9,62.2,62,62,62C61.8,62.1,61.5,62.1,61.3,62.1L61.3,62.1z M61.6,61.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.6-0.3 s0.3-0.3,0.4-0.4s0.2-0.3,0.2-0.5v-1.8c-0.1-0.2-0.2-0.4-0.3-0.6s-0.3-0.3-0.5-0.5s-0.4-0.2-0.6-0.3c-0.2,0-0.4-0.1-0.6-0.1 c-0.3,0-0.6,0-0.9,0.2c-0.2,0.1-0.5,0.3-0.6,0.5s-0.3,0.5-0.4,0.8s-0.1,0.6-0.1,0.9s0,0.6,0.1,0.9c0.1,0.3,0.2,0.5,0.4,0.7 s0.4,0.4,0.7,0.5S61.3,61.2,61.6,61.2L61.6,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66.4,54.5v-1.3h1.1v1.3H66.4z M66.4,62v-6.4h1.1V62H66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.4,62.1c-0.5,0-1-0.1-1.5-0.2s-0.9-0.4-1.3-0.7l0.4-0.7c0.4,0.3,0.7,0.5,1.1,0.6s0.8,0.2,1.2,0.2 c0.4,0,0.8-0.1,1.1-0.3s0.4-0.4,0.4-0.8c0-0.1,0-0.3-0.1-0.4c0-0.1-0.2-0.2-0.3-0.3s-0.3-0.1-0.5-0.2c-0.2,0-0.5-0.1-0.8-0.2 c-0.4-0.1-0.7-0.2-1-0.3s-0.5-0.2-0.7-0.3s-0.3-0.2-0.4-0.4c-0.1-0.1-0.1-0.4-0.1-0.6c0-0.3,0-0.6,0.2-0.8 c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.1,0.5-0.3,0.8-0.4s0.6-0.1,0.9-0.1c0.5,0,0.9,0.1,1.3,0.2s0.7,0.3,1,0.6l-0.5,0.6 c-0.2-0.2-0.6-0.4-0.9-0.5c-0.3-0.1-0.7-0.2-1-0.2c-0.4,0-0.7,0.1-1,0.2c-0.3,0.1-0.4,0.4-0.4,0.8c0,0.1,0,0.2,0.1,0.3 s0.1,0.2,0.2,0.2s0.3,0.1,0.4,0.2c0.2,0,0.4,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1.1,0.3s0.6,0.2,0.8,0.3s0.3,0.3,0.4,0.5 s0.1,0.4,0.1,0.7c0,0.6-0.2,1.1-0.7,1.4C72.8,62,72.2,62.1,71.4,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78.5,61.7c0,0-0.1,0-0.2,0.1S78,61.9,78,61.9c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.5,0 c-0.4,0-0.7-0.1-1-0.3c-0.3-0.2-0.4-0.5-0.4-1v-4.3h-0.9v-0.8h0.9v-2.1h1.1v2.1h1.4v0.8h-1.4v4c0,0.2,0.1,0.4,0.2,0.5 s0.3,0.1,0.5,0.1s0.4,0,0.6-0.1s0.3-0.1,0.3-0.1L78.5,61.7L78.5,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.3,62.1c-0.5,0-0.9-0.1-1.3-0.2s-0.7-0.4-1-0.7s-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.8-0.2-1.3s0.1-0.9,0.2-1.3 s0.4-0.7,0.7-1s0.6-0.5,1-0.7c0.4-0.2,0.8-0.2,1.3-0.2s0.9,0.1,1.3,0.2c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.6,1 c0.1,0.4,0.2,0.8,0.2,1.2v0.4h-5.3c0,0.3,0.1,0.6,0.2,0.9c0.1,0.2,0.3,0.5,0.5,0.7s0.4,0.3,0.6,0.4s0.5,0.1,0.8,0.1 c0.2,0,0.4,0,0.6-0.1s0.3-0.1,0.5-0.2c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.4l0.9,0.2c-0.1,0.2-0.2,0.4-0.4,0.6 s-0.4,0.3-0.6,0.5s-0.5,0.2-0.8,0.3S82.6,62.1,82.3,62.1z M84.4,58.4c0-0.3-0.1-0.6-0.2-0.8s-0.3-0.5-0.5-0.6 c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.1-0.8-0.1s-0.5,0-0.8,0.1S81,56.8,80.8,57c-0.2,0.2-0.3,0.4-0.4,0.6s-0.2,0.5-0.2,0.8 H84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90,56.6c-0.5,0-1,0.1-1.4,0.4c-0.4,0.2-0.7,0.6-0.9,1.1V62h-1.1v-6.3h1v1.5c0.2-0.4,0.5-0.8,0.9-1.1 c0.3-0.3,0.7-0.4,1.1-0.4H90L90,56.6C90,56.6,90,56.6,90,56.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeiCertificate);
export default __webpack_public_path__ + "static/media/lei-certificate.4133f7d7fb845e53e9fb467f61a0d8ed.svg";
export { ForwardRef as ReactComponent };